export default __webpack_public_path__ + "static/media/facebookTW.e49360f8.jpeg";